import React, {forwardRef, useState} from 'react';
import BaseSimpleItemBrowser from "../BaseSimplePage/BaseSimpleItemBrowser";
import TagsItemBrowserHeader from "./TagsItemBrowserHeader";

const TagsItemBrowser = forwardRef(({
                                             ...restProps
                                         }, ref) => {

    const [authorTagKind, setAuthorTagKind] = useState(0);
    const [filterExtraParams, setFilterExtraParams] = useState({});

    function renderHeader(headerProps) {
        return <TagsItemBrowserHeader
            {...headerProps}
            authorTagKind={authorTagKind}
            setAuthorTagKind={handleAuthorTagKindChange}
        />
    }

    function handleAuthorTagKindChange(value) {
        const newFilterExtraParams = {...filterExtraParams};
        if (value === 0)
            delete newFilterExtraParams.author_tag_kinds;
        else
            newFilterExtraParams.author_tag_kinds = value;

        setAuthorTagKind(value);
        setFilterExtraParams(newFilterExtraParams);
        ref.current.onFilterEdit(true);
    }

    return (
        <BaseSimpleItemBrowser
            {...restProps}
            ref={ref}
            renderHeaderFunc={renderHeader}
            filterExtraParams={filterExtraParams}
        />
    );
});

export default TagsItemBrowser;